import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IActionModel } from '../../entities/data-view';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent implements OnInit {

  constructor() { }

  @Input() title: string = "card-header";
  @Input() subTitle: string = undefined;

  @Input() headingSize: number = 1;

  @Input() dangerText: string = undefined;
  @Input() warningText: string = undefined;
  @Input() successText: string = undefined;

  @Input() headerClass: string = 'info';

  @Input() fullHeader: boolean = false;

  @Input() actions: IActionModel[] = undefined;
  @Input() icons: { iconName: string; tooltip: string; size: string; color: string }[] = [];

  @Output() actionInvoke = new EventEmitter<IActionModel>();

  headingSize1: boolean = true;
  headingSize2: boolean = false;
  headingSize3: boolean = false;
  headingSize4: boolean = false;
  headingSize5: boolean = false;
  headingSize6: boolean = false;

  ngOnInit() {
    this.headingSize1 = this.headingSize == 1;
    this.headingSize2 = this.headingSize == 2;
    this.headingSize3 = this.headingSize == 3;
    this.headingSize4 = this.headingSize == 4;
    this.headingSize5 = this.headingSize == 5;
    this.headingSize6 = this.headingSize == 6;
  }

  setTiyleColor(): string {
    switch (this.headerClass) {
      case 'danger':
        return 'view view-cascade overlay gradient-card-header young-passion-gradient py-2';
      case 'warning':
        return 'view view-cascade overlay gradient-card-header sunny-morning-gradient  py-2';
      case 'success':
        return 'view view-cascade overlay gradient-card-header aqua-gradient py-2';
    }
    return 'view view-cascade overlay gradient-card-header blue-gradient py-2';
  }

  actionInvokeImpl(a: IActionModel) {
    this.actionInvoke.emit(a);
  }
}
